/* VÄSSA™ landningssida – paketväljare, sticky ATC, varukorg med upsell, hero-video, reveal.
   Vanilla JS, inga beroenden. Laddas med defer. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return Math.round(cents / 100).toLocaleString('sv-SE') + ' kr'; };
  var cfg = window.VASSA || {};
  var UPSELL_VARIANT = cfg.upsellVariantId ? String(cfg.upsellVariantId) : null;
  var PRODUCT_HANDLE = cfg.productHandle || null;

  /* ---------------- hero-video: spela bara om filen finns ---------------- */
  var heroVideo = $('.js-hero-video');
  if (heroVideo) {
    var hideVideo = function () { heroVideo.style.display = 'none'; };
    heroVideo.addEventListener('error', hideVideo, true);
    var src = heroVideo.querySelector('source');
    if (src) src.addEventListener('error', hideVideo);
    heroVideo.addEventListener('loadeddata', function () { heroVideo.classList.add('is-ready'); });
    var p = heroVideo.play && heroVideo.play();
    if (p && p.catch) p.catch(function () { /* autoplay blockerad – poster/fallback visas */ });
  }

  /* ---------------- reveal on scroll ---------------- */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ro.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.v-reveal').forEach(function (el) { ro.observe(el); });
  } else {
    $$('.v-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------- paketväljare ---------------- */
  var buy = $('.js-buybox');
  var selected = null;
  function selectPack(input) {
    if (!input) return;
    selected = {
      id: input.value,
      price: parseInt(input.getAttribute('data-price'), 10),
      compare: parseInt(input.getAttribute('data-compare'), 10) || 0,
      title: input.getAttribute('data-title') || ''
    };
    $$('.v-pack', buy).forEach(function (l) { l.classList.toggle('is-selected', l.contains(input)); });
    $$('.js-variant-id').forEach(function (h) { h.value = selected.id; });
    $$('.js-price-now').forEach(function (el) { el.textContent = money(selected.price); });
    $$('.js-price-was').forEach(function (el) {
      if (selected.compare > selected.price) { el.textContent = money(selected.compare); el.style.display = ''; } else { el.style.display = 'none'; }
    });
    $$('.js-price-save').forEach(function (el) {
      if (selected.compare > selected.price) { el.textContent = 'Spara ' + money(selected.compare - selected.price); el.style.display = ''; } else { el.style.display = 'none'; }
    });
    $$('.js-selected-title').forEach(function (el) { el.textContent = selected.title; });
    try { history.replaceState(null, '', location.pathname + '?variant=' + selected.id); } catch (e) {}
  }
  if (buy) {
    $$('input[name="pack"]', buy).forEach(function (inp) {
      inp.addEventListener('change', function () { selectPack(inp); });
    });
    selectPack($('input[name="pack"]:checked', buy) || $('input[name="pack"]', buy));
  }

  /* ---------------- galleri ---------------- */
  var mainImg = $('.js-gallery-main');
  $$('.js-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      $$('.js-thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      mainImg.src = btn.getAttribute('data-src');
      mainImg.srcset = btn.getAttribute('data-srcset') || '';
      mainImg.alt = btn.getAttribute('data-alt') || '';
    });
  });

  /* ---------------- sticky ATC på mobil ---------------- */
  var sticky = $('.js-sticky');
  var buyForm = $('.js-buy-form');
  if (sticky && buyForm && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = e.boundingClientRect.top < 0 && !e.isIntersecting;
      sticky.classList.toggle('is-visible', passed && !document.body.classList.contains('v-lock'));
    }, { threshold: 0 });
    so.observe(buyForm);
  }

  /* ---------------- varukorg ---------------- */
  var drawer = $('.js-drawer');
  var toastEl = $('.js-toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('v-lock'); if (sticky) sticky.classList.remove('is-visible'); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('v-lock'); }

  function api(path, body) {
    return fetch(path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var getCart = function () { return api('/cart.js'); };
  var addItem = function (id, qty) { return api('/cart/add.js', { items: [{ id: id, quantity: qty || 1 }] }); };
  var changeLine = function (key, qty) { return api('/cart/change.js', { id: key, quantity: qty }); };

  function lineHTML(it) {
    var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_144x144$1$2') + '" alt="" loading="lazy" width="72" height="72">' : '';
    var price = it.final_line_price < it.original_line_price
      ? '<s>' + money(it.original_line_price) + '</s>' + money(it.final_line_price)
      : money(it.final_line_price);
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="v-line__variant">' + it.variant_title + '</div>' : '';
    return '<div class="v-line" data-key="' + it.key + '">' +
      '<div class="v-line__img">' + img + '</div>' +
      '<div><div class="v-line__title">' + it.product_title + '</div>' + variant +
        '<div class="v-line__row"><div class="v-qty">' +
          '<button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Minska">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Öka">+</button>' +
        '</div><div class="v-line__price">' + price + '</div></div>' +
        '<button type="button" class="v-line__remove" data-qty="0">Ta bort</button>' +
      '</div></div>';
  }

  function renderUpsell(cart) {
    var up = $('.js-upsell');
    if (!up || !UPSELL_VARIANT) return;
    var single = 0, hasProduct = false;
    cart.items.forEach(function (it) {
      if (String(it.variant_id) === UPSELL_VARIANT) single += it.quantity;
      if (PRODUCT_HANDLE && it.handle === PRODUCT_HANDLE) hasProduct = true;
    });
    /* Visas när exakt en "1 st" ligger i korgen: då blir nästa enhet 399 kr via den automatiska rabatten EXTRA399 (−200 kr vid ≥2 st). */
    up.classList.toggle('is-visible', hasProduct && single === 1);
  }

  function paint(cart) {
    var count = cart.item_count;
    $$('.js-cart-count').forEach(function (b) { b.textContent = count; b.classList.toggle('is-visible', count > 0); });
    var list = $('.js-drawer-items');
    if (list) list.innerHTML = cart.items.length ? cart.items.map(lineHTML).join('') : '<p class="v-empty">Din varukorg är tom.</p>';
    var discountTotal = 0, discountTitles = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) { discountTotal += d.total_allocated_amount; discountTitles.push(d.title); });
    cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { discountTotal += a.amount; if (a.discount_application && discountTitles.indexOf(a.discount_application.title) < 0) discountTitles.push(a.discount_application.title); }); });
    var totals = $('.js-totals');
    if (totals) {
      var subtotal = cart.items.reduce(function (s, it) { return s + it.original_line_price; }, 0);
      totals.innerHTML =
        '<div class="v-totals__row"><span>Delsumma</span><span>' + money(subtotal) + '</span></div>' +
        (discountTotal ? '<div class="v-totals__row v-totals__row--discount"><span>Rabatt' + (discountTitles.length ? ' · ' + discountTitles.join(', ') : '') + '</span><span>−' + money(discountTotal) + '</span></div>' : '') +
        '<div class="v-totals__row v-totals__row--total"><span>Totalt</span><span>' + money(cart.total_price) + '</span></div>';
    }
    $$('.js-checkout').forEach(function (b) { b.disabled = !cart.items.length; });
    renderUpsell(cart);
  }

  /* ATC-formulär (huvud + sticky) */
  $$('form.js-atc').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var btn = form.querySelector('[type="submit"]');
      if (!idInput || !idInput.value) return;
      if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.innerHTML); btn.textContent = 'Lägger till…'; }
      addItem(idInput.value, 1)
        .then(getCart)
        .then(function (cart) { paint(cart); openDrawer(); })
        .catch(function (err) { toast((err && err.description) || 'Kunde inte lägga till – försök igen.'); })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = btn.getAttribute('data-label'); } });
    });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.js-open-cart')) { e.preventDefault(); getCart().then(function (c) { paint(c); openDrawer(); }); return; }
    if (t.closest('.js-close-cart')) { closeDrawer(); return; }
    if (t.closest('.js-upsell-add') && UPSELL_VARIANT) {
      var b = t.closest('.js-upsell-add'); b.disabled = true;
      addItem(UPSELL_VARIANT, 1).then(getCart).then(function (c) { paint(c); toast('En extra tillagd – rabatten dras automatiskt i kassan.'); })
        .catch(function () { toast('Kunde inte lägga till – försök igen.'); })
        .then(function () { b.disabled = false; });
      return;
    }
    var q = t.closest('[data-qty]');
    if (q && drawer && drawer.contains(q)) {
      var line = q.closest('[data-key]');
      if (line) changeLine(line.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10)).then(paint).catch(function () { toast('Kunde inte uppdatera varukorgen.'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* videor i rad: spela när de syns, pausa utanför skärmen (spar data/batteri) */
  var vids = document.querySelectorAll('.v-vid__video');
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { vio.observe(v); });
  }

  /* init räknare */
  getCart().then(paint).catch(function () {});
})();
